<div class="kpi-cards" *ngIf="snapshot">
    <div class="kpi-card">
        <div class="kpi-label">{{ 'request_v2.analytics.active_requests' | translate }}</div>
        <div class="kpi-value">{{ snapshot.activeRequests.count }}</div>
        <div class="kpi-subtitle positive">
            {{ 'request_v2.analytics.added_today' | translate:{ count: snapshot.activeRequests.addedToday } }}
        </div>
    </div>
    <div class="kpi-card">
        <div class="kpi-label">{{ 'request_v2.analytics.at_risk_requests' | translate }}</div>
        <div class="kpi-value danger">{{ snapshot.atRiskRequests.count }}</div>
        <div class="kpi-subtitle danger">
            {{ 'request_v2.analytics.added_this_week' | translate:{ count: snapshot.atRiskRequests.addedThisWeek } }}
        </div>
    </div>
    <div class="kpi-card">
        <div class="kpi-label">{{ 'request_v2.analytics.sla_compliance' | translate }}</div>
        <div class="kpi-value">{{ snapshot.slaCompliance.rate }}%</div>
        <div class="kpi-subtitle" *ngIf="slaDelta !== null" [class.positive]="slaDelta > 0" [class.negative]="slaDelta < 0" [class.muted]="slaDelta === 0">
            <span *ngIf="slaDelta > 0">&#9650;</span>
            <span *ngIf="slaDelta < 0">&#9660;</span>
            <span *ngIf="slaDelta === 0">—</span>
            {{ slaDelta > 0 ? '+' : '' }}{{ slaDelta }}% vs {{ 'request_v2.analytics.previous_period' | translate }}
        </div>
        <div class="kpi-subtitle muted" *ngIf="slaDelta === null">
            {{ 'request_v2.analytics.target' | translate }}: {{ snapshot.slaCompliance.target }}%
        </div>
    </div>
    <div class="kpi-card">
        <div class="kpi-label">{{ 'request_v2.analytics.avg_resolution_time' | translate }}</div>
        <div class="kpi-value">{{ snapshot.avgResolutionTime.days }}{{ 'request_v2.analytics.days_unit' | translate }}</div>
        <div class="kpi-subtitle" *ngIf="resolutionDelta !== null" [class.positive]="resolutionDelta < 0" [class.negative]="resolutionDelta > 0" [class.muted]="resolutionDelta === 0">
            <span *ngIf="resolutionDelta < 0">&#9660;</span>
            <span *ngIf="resolutionDelta > 0">&#9650;</span>
            <span *ngIf="resolutionDelta === 0">—</span>
            {{ resolutionDelta > 0 ? '+' : '' }}{{ resolutionDelta }}{{ 'request_v2.analytics.days_unit' | translate }} vs {{ 'request_v2.analytics.previous_period' | translate }}
        </div>
        <div class="kpi-subtitle muted" *ngIf="resolutionDelta === null">
            {{ 'request_v2.analytics.target' | translate }}: {{ snapshot.slaCompliance.target }}%
        </div>
    </div>
</div>
